// extracted by mini-css-extract-plugin
module.exports = {"container":"TabUsps_container__ljWB_","gridItem":"TabUsps_gridItem__YDlVv"};